import { render, staticRenderFns } from "./modifyManual.vue?vue&type=template&id=42046286&scoped=true&"
import script from "./modifyManual.vue?vue&type=script&lang=tsx&"
export * from "./modifyManual.vue?vue&type=script&lang=tsx&"
import style0 from "./modifyManual.vue?vue&type=style&index=0&id=42046286&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42046286",
  null
  
)

export default component.exports